var ExportConfigurationFlags;
(function (ExportConfigurationFlags) {
    ExportConfigurationFlags[ExportConfigurationFlags["KPI"] = 1] = "KPI";
    ExportConfigurationFlags[ExportConfigurationFlags["MODEL"] = 2] = "MODEL";
    ExportConfigurationFlags[ExportConfigurationFlags["LIST_ITEMS"] = 4] = "LIST_ITEMS";
    ExportConfigurationFlags[ExportConfigurationFlags["CONFIGURATION"] = 8] = "CONFIGURATION";
})(ExportConfigurationFlags || (ExportConfigurationFlags = {}));
export function shownInKpis(ec) {
    return !!(ec.flag & ExportConfigurationFlags.KPI);
}
export function shownInConfigurations(ec) {
    return !!(ec.flag & ExportConfigurationFlags.CONFIGURATION);
}
export function shownInListItems(ec) {
    return !!(ec.flag & ExportConfigurationFlags.LIST_ITEMS);
}
export function shownInModel(ec) {
    return !!(ec.flag & ExportConfigurationFlags.MODEL);
}
